import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { UIContext } from '@kaboodle-solutions/design-system';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { getCurrency } from './selectors/booking';
import { withRouter } from 'react-router-dom';

const UIContextProvider = ({ children, currency }) => {
  const [symbol, setSymbol] = useState('£');
  const [exponent, setExponent] = useState(2);

  useEffect(() => {
    if (currency) {
      setSymbol(currency.symbol);
      setExponent(currency.exponent);
    }
  }, [currency]);

  return (
    <UIContext.Provider
      value={{ currencyExponent: exponent, currencySymbol: symbol }}>
      {children}
    </UIContext.Provider>
  );
};

UIContextProvider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  currency: PropTypes.shape({
    symbol: PropTypes.string,
    exponent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

UIContextProvider.defaultProps = {
  currency: null,
};

const mapStateToProps = (state, ownProps) => {
  const bookingReference = ownProps.match.params.booking_reference;

  return {
    currency: getCurrency(state, bookingReference),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, null),
)(UIContextProvider);
